var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDownGraph = function SvgDownGraph(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 40,
    fill: "none",
    viewBox: "0 0 52 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M4 2.75a.75.75 0 0 0-1.5 0v26.667c0 .414.336.75.75.75h26.667a.75.75 0 0 0 0-1.5H4V9.56l12.053 12.053a.75.75 0 0 0 1.06 0l4.47-4.47 6.97 6.97a.75.75 0 0 0 1.06-1.061l-7.5-7.5a.75.75 0 0 0-1.06 0l-4.47 4.47L4 7.439z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B30",
    fillRule: "evenodd",
    d: "M37.997 37.696a1 1 0 0 0 1.358 0l8.744-8.092c.668-.618.23-1.735-.679-1.735H44.96v-9.745a1 1 0 0 0-1-1H32.914a1 1 0 0 0-1 1v9.746h-1.982c-.91 0-1.347 1.116-.68 1.733z",
    clipRule: "evenodd"
  })));
};
export default SvgDownGraph;